import { readFile } from 'roosterjs-editor-dom';

export default function getDataUrlFromFile(file: File): Promise<string> {
    return new Promise<string>(resolve => {
        readFile(file, resolve);
    });
}
